import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const DeleteTariffSlice = createSlice({
  name: "DeleteTariff",
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteTariff: (state, _) => {
      state.isLoading = true;
    },
    successDeleteTariff: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteTariff: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteTariff: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteTariff,
  failureDeleteTariff,
  successDeleteTariff,
  clearDeleteTariff,
} = DeleteTariffSlice.actions;

export default DeleteTariffSlice.reducer;
